import PageHeader from "@/components/PageHeader";
import Footer from "@/components/Footer";
import Enquiry from "@/components/Enquiry";

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#FBF9F5]">
      <PageHeader />
      <div className="pt-16 sm:pt-20" data-testid="contact-page">
        <Enquiry />
      </div>
      <Footer />
    </div>
  );
}
